<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="区域" prop="areaId">
        <a-select
          v-model="form.areaId"
          placeholder="请选择区域（全局配置表示所有区域）"
          style="width: 100%"
          show-search
          :filter-option="filterOption"
          :loading="areaLoading"
        >
          <a-select-option :value="0">全局配置</a-select-option>
          <a-select-option v-for="area in areaList" :key="area.id" :value="area.id">
            {{ area.areaName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="角色类型" prop="roleType">
        <a-select v-model="form.roleType" placeholder="请选择角色类型" style="width: 100%">
          <a-select-option :value="1">平台</a-select-option>
          <a-select-option :value="2">总代理</a-select-option>
          <a-select-option :value="3">门店</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="分销比例值" prop="ratioValue">
        <a-input-number
          v-model="form.ratioValue"
          placeholder="请输入分销比例值（百分比，如10.00=10%）"
          style="width: 100%"
          :min="0"
          :precision="2"
        />
      </a-form-model-item>
      <a-form-model-item label="比例生效开始时间" prop="startTime">
        <a-date-picker
          v-model="startTimeValue"
          show-time
          format="YYYY-MM-DD HH:mm:ss"
          placeholder="请选择开始时间"
          style="width: 100%"
          @change="onChangeStartTime"
        />
      </a-form-model-item>
      <a-form-model-item label="比例生效结束时间" prop="endTime">
        <a-date-picker
          v-model="endTimeValue"
          show-time
          format="YYYY-MM-DD HH:mm:ss"
          placeholder="请选择结束时间（永久填2099-12-31 23:59:59）"
          style="width: 100%"
          @change="onChangeEndTime"
        />
      </a-form-model-item>
      <a-form-model-item label="是否继承上级规则" prop="isInherit">
        <a-select v-model="form.isInherit" placeholder="请选择是否继承" style="width: 100%">
          <a-select-option :value="1">是</a-select-option>
          <a-select-option :value="0">否</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input
          v-model="form.remark"
          type="textarea"
          :rows="3"
          placeholder="请输入备注"
          :max-length="200"
          show-word-limit
        />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
          <a-button type="dashed" @click="cancel">取消</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { addProportionConfig, fetchAreaList } from '@/api/profitSharing/proportion'
import moment from 'moment'

export default {
  name: 'FormDrawer',
  data() {
    return {
      open: false,
      submitLoading: false,
      formTitle: '新增分销比例配置',
      areaList: [],
      areaLoading: false,
      form: {
        areaId: 0,
        roleType: undefined,
        ratioValue: undefined,
        startTime: undefined,
        endTime: undefined,
        isInherit: 0,
        remark: '',
      },
      startTimeValue: undefined,
      endTimeValue: undefined,
      rules: {
        areaId: [{ required: true, message: '请选择区域', trigger: 'change' }],
        roleType: [{ required: true, message: '请选择角色类型', trigger: 'change' }],
        ratioValue: [{ required: true, message: '请输入分销比例值', trigger: 'blur' }],
        startTime: [{ required: true, message: '请选择比例生效开始时间', trigger: 'change' }],
        endTime: [{ required: true, message: '请选择比例生效结束时间', trigger: 'change' }],
        isInherit: [{ required: true, message: '请选择是否继承上级规则', trigger: 'change' }],
      },
    }
  },
  methods: {
    init() {
      this.form = {
        areaId: 0,
        roleType: undefined,
        ratioValue: undefined,
        startTime: undefined,
        endTime: undefined,
        isInherit: 0,
        remark: '',
      }
      this.startTimeValue = undefined
      this.endTimeValue = undefined
      this.formTitle = '新增分销比例配置'
      this.loadAreaList()
      this.open = true
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    loadAreaList() {
      this.areaLoading = true
      fetchAreaList({ status: 1 })
        .then((res) => {
          if (res.success && res.data) {
            this.areaList = res.data || []
          }
          this.areaLoading = false
        })
        .catch(() => {
          this.areaLoading = false
        })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    onChangeStartTime(date, dateString) {
      if (date) {
        this.form.startTime = moment(date).format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.form.startTime = undefined
      }
    },
    onChangeEndTime(date, dateString) {
      if (date) {
        this.form.endTime = moment(date).format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.form.endTime = undefined
      }
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          const params = {
            areaId: this.form.areaId,
            roleType: this.form.roleType,
            ratioValue: this.form.ratioValue,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
            isInherit: this.form.isInherit,
            remark: this.form.remark || undefined,
          }
          addProportionConfig(params)
            .then((res) => {
              if (res.success) {
                this.$message.success('新增成功')
                this.onClose()
                this.$emit('success')
              } else {
                this.$message.error(res.message || '新增失败')
              }
              this.submitLoading = false
            })
            .catch(() => {
              this.submitLoading = false
            })
        }
      })
    },
    cancel() {
      this.onClose()
    },
    onClose() {
      this.open = false
      this.form = {
        areaId: 0,
        roleType: undefined,
        ratioValue: undefined,
        startTime: undefined,
        endTime: undefined,
        isInherit: 0,
        remark: '',
      }
      this.startTimeValue = undefined
      this.endTimeValue = undefined
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
  },
}
</script>

<style lang="less" scoped>
.bottom-control {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 4px 4px;
}
</style>
